/**
 * Speech Capabilities
 *
 * Single gating point for whether live speech recognition (STT +
 * pronunciation assessment) is available on the current platform.
 *
 * As of server-speech-proxy Phase 2, the recognizer routes through the backend
 * WebSocket relay. The relay auth (the SDK forwarding the Supabase JWT as an
 * `Authorization: Bearer` header on the WS upgrade) was device-verified on
 * native only; the browser Speech SDK's upgrade path is not wired to the relay
 * yet, so web is degraded. UI affordances that start recognition — the chat mic
 * button, the pronunciation-exercise recorder, and the Microphone Test screen —
 * gate on this flag and show a "not available on web yet" message instead.
 *
 * TTS is unaffected and stays available on web.
 */

import { Platform } from 'react-native';

/** True when the device can start live speech recognition (native only). */
export const SPEECH_RECOGNITION_AVAILABLE = Platform.OS !== 'web';
